import React from "react";
import PropTypes from "prop-types";
import Styled from "./InvoiceListDesktop.styles";
import { Col, Row } from "reactstrap";
import l10n from "../../../../localization";
import InvoiceEntry from "./_components/InvoiceEntry";

const InvoiceListDesktop = ({
  title,
  invoices,
  gatewayWSPAYForm,
  onOpenInvoice,
  openInvoices,
}) => {
  return (
    <Styled.Card>
      <Styled.Header>
        <Row className="align-items-center">
          <Col md={8}>
            <Styled.Title>{title}</Styled.Title>
          </Col>
          {/* <Col align="right">
            <Button color="danger">Platite sve otvorene račune</Button>
          </Col> */}
        </Row>
      </Styled.Header>
      <Styled.Table>
        <thead>
          <tr>
            <th></th>
            <th>{l10n.invoices.meterLocation}</th>
            <th>{l10n.invoices.invoiceNumber}</th>
            <th>{l10n.invoices.invoiceType}</th>
            <th>{l10n.invoices.period}</th>
            <th>{l10n.invoices.issueDate}</th>
            <th>{l10n.invoices.expirationDate}</th>
            <th>{l10n.invoices.invoiceValue}</th>
            <th>{l10n.invoices.invoiceBalance}</th>
            <th>{l10n.invoices.invoiceDebt}</th>
            <th>{l10n.invoices.pdf}</th>
            {/* <th>{l10n.invoices.payOnline}</th> */}
          </tr>
        </thead>
        <tbody>
          {invoices.length === 0 && (
            <tr>
              <td colSpan="11">
                {openInvoices
                  ? l10n.invoices.noOpenInvoices
                  : l10n.invoices.noInvoices}
              </td>
            </tr>
          )}
          {(invoices || []).map((invoice, invoiceIndex) => (
            <InvoiceEntry
              key={`${invoice.invoiceId}_${invoiceIndex}`}
              invoice={invoice}
              gatewayWSPAYForm={gatewayWSPAYForm}
              onOpenInvoice={onOpenInvoice}
            />
          ))}
        </tbody>
      </Styled.Table>
    </Styled.Card>
  );
};

InvoiceListDesktop.propTypes = {
  openInvoices: PropTypes.bool,
};

InvoiceListDesktop.defaultProps = {
  openInvoices: false,
};

export default InvoiceListDesktop;
